<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-menu-toggle>
          <ion-button>
            <ion-icon
              slot="icon-only"
              name="menu"
              color="light"
            />
          </ion-button>
        </ion-menu-toggle>
      </ion-buttons>
      <ion-title
        color="light"
        @click="goToHome"
      >
        Ollaa Admin
      </ion-title>
      <ion-buttons
        slot="secondary"
      >
        <ion-button
          v-if="offlineMode"
          @click="showOfflineModeInfo"
        >
          <ion-icon
            slot="icon-only"
            color="light"
            name="warning"
          />
        </ion-button>
        <ion-button @click="goToUserInfo">
          <ion-icon
            slot="icon-only"
            color="light"
            name="contact"
          />
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
</template>

<script>
import {
  mapState, mapActions, mapGetters,
} from 'vuex';

export default {
  name: 'Header',
  computed: {
    ...mapState('auth', ['email', 'photoURL']),
    ...mapGetters('auth', ['loggedIn']),
    ...mapState('connection', ['offlineMode']),
  },
  methods: {
    goToUserInfo() {
      this.$router.push('/auth').catch(() => {});
    },
    goToHome() {
      this.$router.push('/').catch(() => {});
    },
    ...mapActions('auth', ['logout']),
    showOfflineModeInfo() {
      this.$ionic.alertController.create({
        header: 'Warnung',
        message: 'Server derzeit nicht erreichbar. Applikation ist im Offlinemodus. Ggf. koennen einige Inhalte nicht mehr angezeigt oder bearbeitet werden.',
        buttons: ['Ok'],
      }).then((alert) => alert.present());
    },
  },
};
</script>


<style lang="scss" scoped>
  ion-title {
    cursor: pointer;
  }
</style>
